import React from 'react';

import { Typography } from '@mui/material';

export function CustomOfferRequiredFieldsLegend() {
  return (
    <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 1, mb: 2 }}>
      * Indicates a required field.
    </Typography>
  );
}
